const { useForm, schema } = require('checkout-off-form-validation');
const { useI18n } = require('nordic/i18n');
const translate = require('../../../translation');

const useMakeAddressSchema = () => {
  const { i18n } = useI18n();
  const translations = translate(i18n);

  return schema.shape({
    zipcode: schema
      .options()
      .required({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(false)
      .validateOnBlur(true),
    state: schema.options().validateOnChange(false).validateOnBlur(true),
    street: schema
      .options()
      .required({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(false)
      .validateOnBlur(true),
    phoneNumber: schema
      .options()
      .min({ message: translations.REQUIRED_FORM_FIELD, length: 8 })
      .validateOnChange(false)
      .validateOnBlur(true),
    email: schema
      .options()
      .email({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(true)
      .validateOnBlur(true),
    name: schema
      .options()
      .custom({
        message: translations.REQUIRED_FORM_FIELD,
        validate: (value) => /\S+([ ]+\S+)+/g.test(value),
      })
      .validateOnChange(false)
      .validateOnBlur(true),
    neighborhood: schema
      .options()
      .required({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(false)
      .validateOnBlur(true),
    streetNumber: schema
      .options()
      .required({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(false)
      .validateOnBlur(true),
    residenceOption: schema
      .options()
      .required({ message: translations.REQUIRED_FORM_FIELD })
      .validateOnChange(false)
      .validateOnBlur(true),
    floor: schema
      .options()
      .optional()
      .validateOnChange(false)
      .validateOnBlur(true),
    description: schema
      .options()
      .optional()
      .validateOnChange(false)
      .validateOnBlur(true),
  });
};

module.exports = {
  useMakeAddressSchema,
};
